// extracted by mini-css-extract-plugin
module.exports = {"logo":"Nav_logo__2ODJZ","arrow":"Nav_arrow__fpL6t"};